/**
 * External dependencies
 */

import React from "react";
import classnames from "classnames";

/**
 * Internal dependencies
 */
import Icon from "components/icon";

/**
 * Style dependencies
 */
import "./styles.scss";

const Gravatar = ({ size = 30, ...props }) => {
  const classes = classnames("gravatar", props.className);
  return (
    <div className={classes} style={{ height: size, width: size }}>
      <Icon name="FaRegUser" />
    </div>
  );
};

export default Gravatar;
